import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Input, Select, Divider } from 'antd'
import type { Tables } from '@muaa/shared'
import { bodyValueProps, normalizeBody } from './create'

type Article = Tables<'articles'>

const CATEGORY_OPTIONS = [
  { value: 'News', label: 'News' },
  { value: 'Alumni Spotlight', label: 'Alumni Spotlight' },
  { value: 'Events', label: 'Events' },
  { value: 'Giving', label: 'Giving' },
  { value: 'Community', label: 'Community' },
]

export function ArticleEdit() {
  const { formProps, saveButtonProps } = useForm<Article>()

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {/* ── Header ─────────────────────────────────────────── */}
        <Divider orientation="left">Header</Divider>
        <Form.Item label="Title" name="title" rules={[{ required: true, message: 'Title is required' }]}>
          <Input placeholder="Article title" />
        </Form.Item>
        <Form.Item label="Category" name="category" rules={[{ required: true, message: 'Category is required' }]}>
          <Select placeholder="Select or type a category" options={CATEGORY_OPTIONS} showSearch allowClear />
        </Form.Item>
        <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Date is required' }]}>
          <Input placeholder="e.g. March 2025" />
        </Form.Item>
        <Form.Item label="Read Time" name="read_time" rules={[{ required: true, message: 'Read time is required' }]}>
          <Input placeholder="e.g. 3 min read" />
        </Form.Item>

        {/* ── Tags ───────────────────────────────────────────── */}
        <Divider orientation="left">Tags</Divider>
        <Form.Item label="Tags" name="tags" tooltip="Topic chips shown in the article detail view">
          <Select mode="tags" tokenSeparators={[',']} placeholder="Type a tag and press Enter" open={false} />
        </Form.Item>

        {/* ── Photo ──────────────────────────────────────────── */}
        <Divider orientation="left">Photo</Divider>
        <Form.Item label="Hero Image URL" name="image_url" tooltip="Leave blank to fall back to the placeholder label below">
          <Input placeholder="https://…/hero.jpg" />
        </Form.Item>
        <Form.Item label="Image Label / Caption" name="image_label">
          <Input placeholder="e.g. CAMPUS PHOTO" />
        </Form.Item>

        {/* ── Attribution ────────────────────────────────────── */}
        <Divider orientation="left">Attribution</Divider>
        <Form.Item label="Author Name" name="author_name">
          <Input placeholder="MUAA News" />
        </Form.Item>
        <Form.Item label="Author Title" name="author_title">
          <Input placeholder="e.g. Alumni Office (optional)" />
        </Form.Item>

        {/* ── Body ───────────────────────────────────────────── */}
        <Divider orientation="left">Body</Divider>
        <Form.Item
          label="Body"
          name="body"
          rules={[{ required: true, message: 'Body is required' }]}
          getValueProps={bodyValueProps}
          normalize={normalizeBody}
        >
          <Input.TextArea
            rows={10}
            placeholder="One paragraph per line. Each line becomes an element in the body array."
          />
        </Form.Item>

        {/* ── Link ───────────────────────────────────────────── */}
        <Divider orientation="left">Link</Divider>
        <Form.Item label="Link Label" name="link_label">
          <Input placeholder="Read on muasda.org" />
        </Form.Item>
        <Form.Item label="Link URL" name="link_url">
          <Input placeholder="https://www.muasda.org/news/" />
        </Form.Item>
      </Form>
    </Edit>
  )
}
